export default {
  categories: [
    {
      image: 'https://m.media-amazon.com/images/I/71n1eP8swUL._AC_UY654_QL65_.jpg',
      displayName: 'Upright Vacuums',
      slug: 'upright-vacuums',
    },
    {
      image: 'https://m.media-amazon.com/images/I/71jG+e7roXL._AC_UY654_QL65_.jpg',
      displayName: 'Laptops',
      slug: 'laptops',
    },
    {
      image: 'https://m.media-amazon.com/images/I/71mD6gBAp2S._AC_UY654_QL65_.jpg',
      displayName: 'Instant Tents',
      slug: 'instant-tents',

      productsAnalyzedDuringRanking: 39,
    },
    {
      image: 'https://m.media-amazon.com/images/I/81mkzEPtKZL._AC_SX654_QL65.jpg',
      displayName: 'Roku Devices',
      slug: 'rokus',
    },
    {
      image: 'https://m.media-amazon.com/images/I/91KZbi-CbzL._AC_UY654_QL65_.jpg',
      displayName: '55 inch TVs',
      slug: '55-inch-tvs',
    },
  ],
  popularCategories: ({device = 'desktop'}: {device: 'desktop' | 'mobile'}) => [
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-vacuums-floor-care.png`,
      title: 'Vacuums & Floor Care',
      categories: [
        {title: 'Robotic Vacuums', href: '/robotic-vacuums'},
        {title: 'Upright Vacuums', href: '/upright-vacuums'},
        {title: 'Steam Mops', href: '/vacuum-mops'},
        {title: 'Handheld Vacuums', href: '/handheld-vacuums'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-computers-accessories.png`,
      title: 'Computers & Accessories',
      categories: [
        {title: 'Laptops', href: '/laptops'},
        {title: 'Gaming Laptops', href: '/gaming-laptops'},
        {title: 'Cable Modem', href: '/cable-modem'},
        {title: 'Dell Laptops', href: '/dell-laptops'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-outdoor-recreation.png`,
      title: 'Outdoor Recreation',
      categories: [
        {title: 'Inflatable Paddle Boards', href: '/inflatable-paddle-boards'},
        {title: 'Instant Tents', href: '/instant-tents'},
        {title: 'Beach Chairs', href: '/beach-chairs'},
        {title: 'Cooler Like Yeti', href: '/cooler-like-yeti'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categrories-television-video.png`,
      title: 'Television & Video',
      categories: [
        {title: 'Roku Devices', href: '/roku-devices'},
        {title: '55 inch TVs', href: '/55-inch-tvs'},
        {title: '43 inch TVs', href: '/43-inch-tvs'},
        {title: '32 inch Smart TVs', href: '/32-inch-smart-tvs'},
      ],
    },
  ],
}
